import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TransportersApi } from 'api';

/**
 * Custom React Query hook to delete a carrier
 *
 * @param {{ onSuccess?: () => void; onError?: (error: Error) => void }} options
 * @returns {import("@tanstack/react-query").UseMutationResult}
 */
export function useDeleteTransporter({ onSuccess, onError } = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => TransportersApi.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries(['transporters']);
      typeof onSuccess === 'function' && onSuccess();
    },
    onError: (error) => {
      typeof onError === 'function' && onError(error);
    },
  });
}
